// Import
import Vue from 'vue'
import App from './App.vue'
import VAnimateCss from 'v-animate-css'
import VueAnimateOnscoll from 'vue-animate-onscroll'
import PubSub from 'pubsub-js'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import router from './router'
import store from './store/store.js'
import 'easy-circular-progress'
import 'academicons/css/academicons.min.css'

// Import Element-UI
import { Timeline, TimelineItem, Card, Tabs, TabPane } from 'element-ui'
import "./assets/style/global.css"


// Use Middleware
Vue.use(VueRouter)
Vue.use(VueMeta)
Vue.use(VAnimateCss)
Vue.use(VueAnimateOnscoll)
Vue.use(PubSub)
// Close the production tip
Vue.config.productionTip = false

// Use Element-UI Components
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Card)
Vue.use(Tabs)
Vue.use(TabPane)

new Vue({
    router,     // Apply Vue-router
    store,      // Apply Vuex
    render: h => h(App),
}).$mount('#app')
